import React from 'react';
import { X } from 'react-feather';
import { Link, useLocation } from 'react-router-dom';
import BgIconBottom from 'assets/images/bg_icon_bottom.png';
import { menuData } from './menuData';
import { useAuth } from 'core/contexts/auth/AuthContext';
import { PermissionsGate } from 'components/PermissionsGate';
import palette from 'core/constant/palette';


type props = {
    handleClose: () => void;
}

const NavBarMobile = ({handleClose} : props) => {
    let location = useLocation();
    const { user } = useAuth();
  return (
    <div className=' fixed inset-0 bg-bg_brown z-20 overflow-y-auto'>
        <div className=' relative w-full min-h-full flex items-start justify-center'>
            {/* Was a `div`. Its 48px box was already big enough to hit; what it
                had no way of being was focused, so once the menu was open a
                keyboard had no way to shut it. */}
            <button
            type='button'
            aria-label='Đóng menu'
            className=' absolute top-2 right-2 p-3 flex items-center justify-center rounded-full
              focus:outline-none focus-visible:ring-2 focus-visible:ring-gold'
            onClick={() => handleClose()}
            >
                <X size={24} color={palette.gold}/>
            </button>
            <div className=' text-secondary flex flex-col gap-y-8 pt-[140px] pb-[160px] text-center'>
                {menuData?.map((item) => {
                    const isActive = item.path.includes('/quan-ly')
                        ? location?.pathname?.includes('/quan-ly')
                        : location?.pathname === item.path;
                    // `py-3 -my-3` grows the target to 44px without moving the
                    // text: the padding the finger gets back, the margin gives
                    // straight back to the layout.
                    const link = (
                        <Link
                        to={item.path}
                        onClick={handleClose}
                        className=' cursor-pointer block py-3 -my-3 rounded
                          focus:outline-none focus-visible:ring-2 focus-visible:ring-gold'
                        >
                            <p className={`${isActive ? 'text-white font-bold' : ''}`}>
                                {item.title}
                            </p>
                        </Link>
                    );
                    return item.roles.length === 0 ? (
                        <React.Fragment key={item.id}>{link}</React.Fragment>
                    ) : (
                        <PermissionsGate user={user} scopes={item.roles} key={item.id}>
                            {link}
                        </PermissionsGate>
                    );
                })}
            </div>
            <img src={BgIconBottom} alt="" className='w-full h-[127px] fixed bottom-0 right-0 left-0 z-[6] bg-bg_brown pointer-events-none'/>
        </div>
    </div>
  )
}

export default NavBarMobile